import { isEmpty } from '@sigma-frontend-libs/commons'

import render from './render'

export default {
  name: 'InfoCard',

  props: {
    value: {
      type: [ String, Number ],
      default: undefined
    },

    label: {
      type: [ String, Number ],
      default: undefined
    },

    copy: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    $_class() {
      return {
        ['info-card']: true,
        ['info-card--copy']: this.copy
      }
    },

    hasContent() {
      return !isEmpty(this.value)
    }
  },

  render
}
